/**
 * API · core.list_assignable_users
 *
 * Roster mínimo para pickers de asignación (owner / assignee / watcher /
 * mention). SECURITY DEFINER en server con output controlado — cualquier
 * authenticated user puede consultarlo sin necesitar employees.view ni
 * users.manage.
 *
 * Fuente: auth.users LEFT JOIN core.employee_profile. Si el user no tiene
 * employee_profile, display_name cae a meta-data o al local-part del email.
 */
import { supabase } from '@/lib/supabase';

export interface AssignableUser {
  user_id: string;
  display_name: string;
  avatar_url: string | null;
  email: string;
  is_active: boolean;
}

export async function listAssignableUsers(): Promise<AssignableUser[]> {
  const { data, error } = await (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    supabase.schema('core' as any) as any
  ).rpc('list_assignable_users');
  if (error) throw error;
  return (data ?? []) as AssignableUser[];
}
